// extracted by mini-css-extract-plugin
module.exports = {"container":"markets_container__Pqevc","tabs":"markets_tabs__Hhrte","moreBtn":"markets_moreBtn__oCl9n","headerContainer":"markets_headerContainer__QV3e5"};